/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LayerFarmProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const layerFarmProcessFetchListLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const layerFarmProcessFetchListSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LayerFarmProcessTypes.LAYER_FARM_PROCESS_FETCH_LIST_LOADING]: layerFarmProcessFetchListLoading,
  [LayerFarmProcessTypes.LAYER_FARM_PROCESS_FETCH_LIST_SUCCESS]: layerFarmProcessFetchListSuccess
});
